export enum KeyRecoveryStatus {
  INIT = 'INIT',
  VERIFIED = 'VERIFIED',
  SIGNED = 'SIGNED',
}

export interface IKeyRecoveryInfo {
  id: number;
  organizationId: number;
  organizationName: number;
  initiatorId: number;
  initiatorName: string;
  lastUpdatedDate: string;
  status: KeyRecoveryStatus;
}
